import React, { useState } from "react";
import Modal from "./ui/Modal";
import Button from "./ui/Button";
import TextInput from "./ui/TextInput";

const PasswordDialog = ({ open, onClose, onPasswordChange, loading }) => {
  // Local state that won't be affected by parent re-renders
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!currentPassword || !newPassword) {
      setError("All fields are required");
      return;
    }

    try {
      await onPasswordChange({
        currentPassword,
        newPassword,
        confirmPassword,
      });

      // Clear form on success
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
      onClose();
    } catch (error) {
      setError("Failed to change password");
    }
  };

  const handleClose = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      panelClassName="w-full max-w-md rounded-2xl border-2 border-brand-purple/40 bg-surface-card/95 backdrop-blur-xl shadow-card"
    >
      <div className="px-6 pt-6 pb-2">
        <h3 className="flex items-center gap-2 text-xl font-heading font-bold text-brand-purple">
          <span className="text-2xl">🔒</span>
          Change Password
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="px-6 pb-2 pt-2 space-y-4">
        <TextInput
          label="Current Password"
          icon="🔒"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          autoComplete="current-password"
        />
        <TextInput
          label="New Password"
          icon="🔒"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoComplete="new-password"
        />
        <TextInput
          label="Confirm Password"
          icon="🔒"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          autoComplete="new-password"
        />

        {error && <p className="text-red-400 text-sm">{error}</p>}

        <div className="flex justify-end gap-3 pb-6 pt-2">
          <Button type="button" variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "Changing..." : "Change Password"}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default PasswordDialog;
